import Layout from "../../components/Layout";
import Support from "./Support";

const index = () => {
  return (
    <Layout
      children={
        <Support />
      }
    />
  );
};

export default index;
